var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.27 3.39c.5.46.53 1.2.1 1.7l-.1.11-5.72 5.52h14.12c.73 0 1.33.57 1.33 1.28a1.3 1.3 0 01-1.2 1.29H6.55l5.72 5.52a1.23 1.23 0 01.38.9 1.27 1.27 0 01-.38.9c-.48.48-1.25.52-1.78.1l-.1-.08-8-7.72-.05-.06-.1-.1-.05-.1-.04-.06a1.25 1.25 0 01-.05-1.08l.06-.13.09-.12.07-.1.07-.07 8-7.71c.52-.5 1.37-.5 1.88 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.1befc092bb9a32c1f83e4b7466ac232c.svg";